/**
 * .top_btn 스크롤 시 .active — 클릭은 LenisController.initBackToTop 이 처리
 */
export class HomeTopButton {
    static init(): void {
        const $ = (window as unknown as { $?: (s: string) => JQueryTop }).$;
        if (!$) return;

        const $topBtn = $(".top_btn");
        function toggleTopButton(): void {
            const scrollTop = $(window).scrollTop() ?? 0;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;
            const canScroll = documentHeight > windowHeight + 10;
            if (canScroll && scrollTop > 20) {
                $topBtn.addClass("active");
            } else {
                $topBtn.removeClass("active");
            }
        }
        toggleTopButton();
        $(window).on("scroll resize load", toggleTopButton);
    }
}

interface JQueryTop {
    scrollTop(): number | undefined;
    on(ev: string, fn: () => void): JQueryTop;
    addClass(c: string): JQueryTop;
    removeClass(c: string): JQueryTop;
}
